import styled from 'styled-components';

import { IButtonProps } from './Button.type';

export const Container = styled.button<IButtonProps>`
	width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
	height: ${({ height }) => height || 'auto'};

	padding: 12px 20px;

	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;

	background-color: ${({ theme, bgColor }) =>
		bgColor ? theme[bgColor] : theme['orange-primary']};
	border-radius: ${({ roundness }) => (roundness ? '100px' : '6px')};
	border: ${({ theme, borderColor }) =>
		borderColor ? `${theme[borderColor]} 1px solid` : 'none'};
`;
